// extracted by mini-css-extract-plugin
module.exports = {"section":"transform-customers-experience_section__E_ejI","item__wrapper":"transform-customers-experience_item__wrapper__2BfaV","list":"transform-customers-experience_list__1t3Om"};